export class SchemaUtil {
  static basic = {
    id: null,
    name: null,
  }

  static address = {
    city: null,
    companyName: null,
    country: null,
    dic: null,
    email: null,
    externalId: null,
    firstName: null,
    ic: null,
    id: null,
    isBilling: null,
    isStored: null,
    lastName: null,
    note: null,
    phone: null,
    state: null,
    street: null,
    branchId: null,
    zip: null,
  }

  static category = {
    id: null,
    externalId: null,
    name: null,
    text: null,
    parent: {
      id: null,
    },
    children: {
      id: null,
      name: null,
    },
    hasChildren: null,
    position: null,
    company: {
      id: null,
      name: null,
    },
    treePath: null,
    tags: {
      id: null,
      name: null,
    },
  }

  static productDepot = {
    id: null,
    depot: {
      id: null,
      name: null,
    },
    supplier: {
      id: null,
      name: null,
    },
    purchasePrice: null,
    quantityStock: null,
    position: null,
    position1: null,
    position2: null,
    position3: null,
    expirationDate: null,
    batch: null,
    updated: null,
  }

  static productDepotMetric = {
    id: null,
    depot: {
      id: null,
    },
    product: {
      id: null,
    },
    quantityMinimum: null,
    quantityOptimum: null,
    quantityStock: null,
    quantityPurchase: null,
  }

  static quantity = {
    depot: {
      id: null,
      name: null,
    },
    quantityStock: null,
    quantityReservation: null,
    quantityAvailable: null,
  }

  static institution = {
    id: null,
    name: null,
    checkouts: {
      id: null,
      name: null,
    },
    depots: {
      id: null,
      name: null,
    },
  }

  static checkout = {
    id: null,
    name: null,
    deletable: null,
    institution: {
      id: null,
      name: null,
    },
    depots: {
      id: null,
      name: null,
      unavailablesUrl: null,
    },
  }

  static carrier = {
    id: null,
    name: null,
    color: null,
    position: null,
    tariffs: {
      id: null,
      name: null,
      const: null,
      position: null,
      cod: null,
    },
  }

  static companyCarrier = {
    id: null,
    enable: null,
    options: null,
    carrier: SchemaUtil.carrier,
    checkout: {
      id: null,
      name: null,
    },
    externalId: null,
  }

  static customer = {
    id: null,
    addresses: SchemaUtil.address,
    birthday: null,
    consentRelations: { id: null, consent: { id: null }, name: null, body: null },
    email: null,
    firstName: null,
    lastName: null,
    companyName: null,
    minExpirationDays: null,
    name: null,
    note: null,
    phone: null,
    priceLevel: { id: null, name: null, isPercentage: null, percent: null, withVat: null, currency: { id: null } },
    tags: { id: null, name: null, type: null, color: null, externalId: null },
    users: { id: null, email: null, firstName: null, lastName: null, name: null },
    wholesale: null,
  }

  static file = {
    id: null,
    text: null,
    originalFilename: null,
    main: null,
    mimeType: null,
    size: null,
    url: null,
    thumbnails: {
      format: null,
      mimeType: null,
      url: null,
    },
  }

  static user = {
    id: null,
    email: null,
    firstName: null,
    lastName: null,
    locale: null,
    name: null,
    phone: null,
    groups: {
      id: null,
      name: null,
      roles: null,
    },
    roles: null,
    pin: null,
    company: {
      id: null,
      name: null,
      currency: {
        id: null,
        name: null,
        ratio: null,
      },
    },
    depots: {
      id: null,
      name: null,
    },
    checkouts: {
      id: null,
      name: null,
    },
    enabled: null,
  }

  static userProfile = {
    id: null,
    email: null,
    firstName: null,
    lastName: null,
    locale: null,
    name: null,
    phone: null,
    groups: {
      id: null,
      name: null,
      roles: null,
      externalId: null,
    },
    roles: null,
    pin: null,
    company: {
      enabledPositions: null,
      batchExpirationMode: null,
      id: null,
      name: null,
      ic: null,
      dic: null,
      email: null,
      phone: null,
      street: null,
      city: null,
      zip: null,
      country: null,
      currency: {
        id: null,
        name: null,
        ratio: null,
      },
      registrationNote: null,
      nextEan: null,
      billLogo: null,
      defaultVoucherValidity: null,
      externalId: null,
      customOptions: null,
      parent: {
        id: null,
        name: null,
        ic: null,
        dic: null,
        email: null,
        phone: null,
        street: null,
        city: null,
        zip: null,
        country: null,
        registrationNote: null,
        nextEan: null,
        billLogo: null,
        parent: {
          id: null,
          name: null,
        },
        children: {
          id: null,
          name: null,
        },
        carrierRelations: {
          id: null,
        },
      },
      carrierRelations: {
        id: null,
        enable: null,
        options: null,
        carrier: {
          id: null,
          name: null,
        },
        checkout: {
          id: null,
          name: null,
        },
        externalId: null,
      },
    },
    depots: {
      id: null,
      name: null,
    },
    checkouts: {
      id: null,
      name: null,
    },
    enabled: null,
    deletable: null,
  }

  static sellItem = {
    id: null,
    quantityStock: null,
    quantityReservation: null,
    quantityAvailable: null,
    expirationDate: null,
    batch: null,
    productDepots: {
      id: null,
      depot: {
        id: null,
        name: null,
      },
      supplier: {
        id: null,
        name: null,
      },
      purchasePrice: null,
      quantityStock: null,
      inventoryQuantityStock: null,
      batch: null,
      expirationDate: null,
      position: null,
      position1: null,
      position2: null,
      position3: null,
      created: null,
      updated: null,
    },
  }

  static soldItem = {
    name: null,
    type: null,
    ean: null,
    code: null,
    quantity: null,
    priceAll: null,
    priceAllWithoutVat: null,
    product: {
      id: null,
      fullName: null,
      mainImage: {
        id: null,
        text: null,
        mimeType: null,
        url: null,
        thumbnails: { format: null, mimeType: null, url: null },
      },
    },
    profit: null,
  }

  static EETShop = {
    cert: {
      id: null,
      name: null,
      publicKey: null,
      expirationDate: null,
    },
    checkouts: { id: null, name: null },
    city: null,
    country: null,
    eetId: null,
    id: null,
    name: null,
    street: null,
    zip: null,
  }

  static parameter = {
    id: null,
    enumValues: null,
    externalId: null,
    name: null,
    text: null,
    type: null,
    unit: null,
    company: {
      id: null,
    },
  }

  static productParameter = {
    id: null,
    value: null,
    externalId: null,
    parameter: SchemaUtil.parameter,
    product: {
      id: null,
    },
  }

  static payment = {
    id: null,
    name: null,
    type: {
      id: null,
      name: null,
    },
    eetEnable: null,
  }

  static productImportSearch = {
    id: null,
    name: null,
    fullName: null,
    ean: null,
    code: null,
  }

  // M-kod, Kod vyrobce a DL-kod budou na serveru code, code2 a code3
  static productList = {
    enabledBatchExpiration: null,
    id: null,
    name: null,
    fullName: null,
    ean: null,
    code: null,
    code2: null,
    code3: null,
    purchaseCurrency: {
      id: null,
      name: null,
      ratio: null,
    },
    sellPrice: null,
    actualSellPrice: null,
    purchasePrice: null,
    enabled: null,
    isFragile: null,
    isOversize: null,
    mainImage: SchemaUtil.file,
    quantityStock: null,
    quantityReservation: null,
    quantityAvailable: null,
    productDepots: SchemaUtil.productDepot, // have to be here because of quantity stock overview modal...
    children: {
      id: null,
      name: null,
      fullName: null,
      ean: null,
      code: null,
      sellPrice: null,
      actualSellPrice: null,
      enabled: null,
      isFragile: null,
      isOversize: null,
      mainImage: SchemaUtil.file,
      quantityStock: null,
      quantityReservation: null,
      quantityAvailable: null,
    },
    tags: {
      id: null,
      name: null,
      type: null,
      color: null,
      externalId: null,
    },
    packs: {
      id: null,
      ean: null,
      code: null,
      quantity: null,
      externalId: null,
      note: null,
    },
    quantities: SchemaUtil.quantity,
    metrics: {
      id: null,
      depot: {
        id: null,
        name: null,
      },
      product: {
        id: null,
      },
      quantityMinimum: null,
      quantityOptimum: null,
      quantityMaximum: null,
      quantityPurchase: null,
    },
  }

  static clearanceItem = {
    id: null,
    amount: null,
    batch: null,
    expirationDate: null,
    packed: null,
    picked: null,
    position: null,
    position1: null,
    position2: null,
    position3: null,
    product: {
      id: null,
      name: null,
      fullName: null,
      code: null,
      ean: null,
      productDepots: SchemaUtil.productDepot,
      mainImage: SchemaUtil.file,
    },
    quantityAvailable: null,
    quantityReservation: null,
    productDepots: SchemaUtil.productDepot,
  }

  static depot = {
    id: null,
    name: null,
    emailIn: null,
    unavailablesUrl: null,
    externalId: null,
    company: {
      id: null,
    },
    companyCarriers: {
      id: null,
      name: null,
    },
    checkouts: {
      id: null,
      name: null,
    },
    created: null,
    updated: null,
    deletable: null,
  }

  static product = {
    id: null,
    productDepots: {
      id: null,
      depot: {
        id: null,
        name: null,
        unavailablesUrl: null,
      },
      supplier: {
        id: null,
        name: null,
      },
      purchasePrice: null,
      quantityStock: null,
      inventoryQuantityStock: null,
      batch: null,
      expirationDate: null,
      position: null,
      position1: null,
      position2: null,
      position3: null,
      created: null,
      updated: null,
    },
    name: null,
    fullName: null,
    ean: null,
    ean2: null,
    ean3: null,
    ean4: null,
    ean5: null,
    code: null,
    code2: null,
    code3: null,
    externalId: null,
    purchaseCurrency: {
      id: null,
      name: null,
      ratio: null,
    },
    purchasePrice: null,
    sellPrice: null,
    sellPriceWithoutVat: null,
    beforeSellPrice: null,
    actualSellPrice: null,
    actualSellPriceWithoutVat: null,
    actualBeforeSellPrice: null,
    weight: null,
    enabled: null,
    parent: {
      id: null,
      name: null,
      fullName: null,
      ean: null,
      ean2: null,
      ean3: null,
      ean4: null,
      ean5: null,
      code: null,
      externalId: null,
      purchaseCurrency: {
        id: null,
        name: null,
        ratio: null,
      },
      purchasePrice: null,
      sellPrice: null,
      sellPriceWithoutVat: null,
      beforeSellPrice: null,
      actualSellPrice: null,
      actualSellPriceWithoutVat: null,
      actualBeforeSellPrice: null,
      weight: null,
      enabled: null,
      isFragile: null,
      isOversize: null,
      producer: {
        id: null,
        name: null,
      },
      isForSubsequentSettlement: null,
      mainImage: SchemaUtil.file,
      children: {
        id: null,
      },
    },
    children: {
      id: null,
      name: null,
      fullName: null,
      ean: null,
      ean2: null,
      ean3: null,
      ean4: null,
      ean5: null,
      code: null,
      externalId: null,
      purchaseCurrency: {
        id: null,
        name: null,
        ratio: null,
      },
      purchasePrice: null,
      sellPrice: null,
      sellPriceWithoutVat: null,
      beforeSellPrice: null,
      actualSellPrice: null,
      actualSellPriceWithoutVat: null,
      actualBeforeSellPrice: null,
      weight: null,
      enabled: null,
      isFragile: null,
      isOversize: null,
      note: null,
      hsCode: null,
      isDeletable: null,
      dimensionX: null,
      dimensionY: null,
      dimensionZ: null,
      originCountry: null,
      producer: {
        id: null,
        name: null,
      },
      vat: {
        id: null,
      },
      isForSubsequentSettlement: null,
      mainImage: SchemaUtil.file,
      productPriceLevels: {
        id: null,
        sellPrice: null,
        externalId: null,
        priceLevel: {
          id: null,
        },
      },
      parent: {
        id: null,
      },
      quantityAvailable: null,
      quantityReservation: null,
      quantityStock: null,
    },
    isFragile: null,
    isOversize: null,
    producer: {
      id: null,
      name: null,
    },
    vat: {
      id: null,
      name: null,
      percent: null,
      coefficient: null,
      default: null,
    },
    supplier: {
      id: null,
      name: null,
    },
    isForSubsequentSettlement: null,
    mainImage: SchemaUtil.file,
    images: SchemaUtil.file,
    files: SchemaUtil.file,
    advancedPrices: {
      id: null,
      product: {
        id: null,
        name: null,
        productDepots: {
          id: null,
        },
      },
      sellPrice: null,
      available: null,
      dateFrom: null,
      dateTo: null,
      isActual: null,
      note: null,
    },
    packs: {
      id: null,
      ean: null,
      code: null,
      quantity: null,
      externalId: null,
      note: null,
    },
    productParameters: {
      id: null,
      value: null,
      externalId: null,
      parameter: SchemaUtil.parameter,
      product: {
        id: null,
      },
    },
    quantityAvailable: null,
    quantityStock: null,
    quantityPurchase: null,
    note: null,
    description: null,
    customData: null,
    categories: {
      id: null,
      externalId: null,
      name: null,
      text: null,
      parent: {
        id: null,
        externalId: null,
        name: null,
        text: null,
        parent: {
          id: null,
          name: null,
        },
        children: {
          id: null,
          name: null,
        },
        hasChildren: null,
        position: null,
        treePath: null,
        tags: {
          id: null,
        },
      },
      children: {
        id: null,
        externalId: null,
        name: null,
        text: null,
        parent: {
          id: null,
          name: null,
        },
        children: {
          id: null,
          name: null,
        },
        hasChildren: null,
        position: null,
        treePath: null,
        tags: {
          id: null,
        },
      },
      hasChildren: null,
      position: null,
      treePath: null,
      tags: {
        id: null,
      },
    },
    mainCategory: {
      id: null,
      externalId: null,
      name: null,
      text: null,
      parent: {
        id: null,
        externalId: null,
        name: null,
        text: null,
        parent: {
          id: null,
          name: null,
        },
        children: {
          id: null,
          name: null,
        },
        hasChildren: null,
        position: null,
        treePath: null,
        tags: {
          id: null,
        },
      },
      children: {
        id: null,
        externalId: null,
        name: null,
        text: null,
        parent: {
          id: null,
          name: null,
        },
        children: {
          id: null,
          name: null,
        },
        hasChildren: null,
        position: null,
        treePath: null,
        tags: {
          id: null,
        },
      },
      hasChildren: null,
      position: null,
      treePath: null,
      tags: {
        id: null,
      },
    },
    productPriceLevels: {
      id: null,
      sellPrice: null,
      externalId: null,
      priceLevel: {
        id: null,
        name: null,
        isPercentage: null,
        percent: null,
        withVat: null,
        currency: {
          id: null,
          name: null,
        },
        externalId: null,
      },
    },
    tags: {
      id: null,
      name: null,
      type: null,
      color: null,
      externalId: null,
    },
    quantities: SchemaUtil.quantity,
    sellItems: SchemaUtil.sellItem,
    isDeletable: null,
    dimensionX: null,
    dimensionY: null,
    dimensionZ: null,
    originCountry: null,
    hsCode: null,
    metrics: SchemaUtil.productDepotMetric,
    enabledBatchExpiration: null,
  }

  static productForStats = {
    id: null,
    name: null,
    fullName: null,
    ean: null,
    ean2: null,
    ean3: null,
    ean4: null,
    ean5: null,
    code: null,
    code2: null,
    code3: null,
    externalId: null,
    // purchaseCurrency: {
    //   id: null,
    //   name: null,
    //   ratio: null,
    // },
    purchasePrice: null,
    sellPrice: null,
    sellPriceWithoutVat: null,
    beforeSellPrice: null,
    actualSellPrice: null,
    actualSellPriceWithoutVat: null,
    actualBeforeSellPrice: null,
    weight: null,
    enabled: null,
    isFragile: null,
    isOversize: null,
    vat: {
      id: null,
      name: null,
      percent: null,
      coefficient: null,
      default: null,
    },
    isForSubsequentSettlement: null,
    mainImage: SchemaUtil.file,
    quantityStock: null,
    quantityPurchase: null,
    note: null,
    description: null,
    customData: null,
    isDeletable: null,
    dimensionX: null,
    dimensionY: null,
    dimensionZ: null,
    originCountry: null,
    hsCode: null,
    enabledBatchExpiration: null,
  }

  static duplicatedProduct = {
    id: null,
    name: null,
    fullName: null,
    purchaseCurrency: {
      id: null,
      name: null,
      ratio: null,
    },
    purchasePrice: null,
    sellPrice: null,
    sellPriceWithoutVat: null,
    beforeSellPrice: null,
    actualSellPrice: null,
    actualSellPriceWithoutVat: null,
    actualBeforeSellPrice: null,
    weight: null,
    enabled: null,
    parent: {
      id: null,
      name: null,
      fullName: null,
      ean: null,
      ean2: null,
      ean3: null,
      ean4: null,
      ean5: null,
      code: null,
      externalId: null,
      purchaseCurrency: {
        id: null,
        name: null,
        ratio: null,
      },
      purchasePrice: null,
      sellPrice: null,
      sellPriceWithoutVat: null,
      beforeSellPrice: null,
      actualSellPrice: null,
      actualSellPriceWithoutVat: null,
      actualBeforeSellPrice: null,
      weight: null,
      enabled: null,
      isFragile: null,
      isOversize: null,
      producer: {
        id: null,
        name: null,
      },
      isForSubsequentSettlement: null,
      mainImage: SchemaUtil.file,
      children: {
        id: null,
      },
    },
    isFragile: null,
    isOversize: null,
    producer: {
      id: null,
      name: null,
    },
    vat: {
      id: null,
      name: null,
      percent: null,
      coefficient: null,
      default: null,
    },
    supplier: {
      id: null,
      name: null,
    },
    isForSubsequentSettlement: null,
    mainImage: SchemaUtil.file,
    images: SchemaUtil.file,
    files: SchemaUtil.file,
    advancedPrices: {
      id: null,
      product: {
        id: null,
        name: null,
        productDepots: {
          id: null,
        },
      },
      sellPrice: null,
      available: null,
      dateFrom: null,
      dateTo: null,
      isActual: null,
      note: null,
    },
    packs: {
      id: null,
      ean: null,
      code: null,
      quantity: null,
      externalId: null,
      note: null,
    },
    quantityStock: null,
    note: null,
    description: null,
    customData: null,
    categories: {
      id: null,
      externalId: null,
      name: null,
      text: null,
      parent: {
        id: null,
        externalId: null,
        name: null,
        text: null,
        parent: {
          id: null,
          name: null,
        },
        children: {
          id: null,
          name: null,
        },
        hasChildren: null,
        position: null,
        treePath: null,
        tags: null,
      },
      children: {
        id: null,
        externalId: null,
        name: null,
        text: null,
        parent: {
          id: null,
          name: null,
        },
        children: {
          id: null,
          name: null,
        },
        hasChildren: null,
        position: null,
        treePath: null,
        tags: null,
      },
      hasChildren: null,
      position: null,
      treePath: null,
      tags: null,
    },
    mainCategory: {
      id: null,
      externalId: null,
      name: null,
      text: null,
      parent: {
        id: null,
        externalId: null,
        name: null,
        text: null,
        parent: {
          id: null,
          name: null,
        },
        children: {
          id: null,
          name: null,
        },
        hasChildren: null,
        position: null,
        treePath: null,
        tags: null,
      },
      children: {
        id: null,
        externalId: null,
        name: null,
        text: null,
        parent: {
          id: null,
          name: null,
        },
        children: {
          id: null,
          name: null,
        },
        hasChildren: null,
        position: null,
        treePath: null,
        tags: null,
      },
      hasChildren: null,
      position: null,
      treePath: null,
      tags: null,
    },
    productPriceLevels: {
      id: null,
      sellPrice: null,
      externalId: null,
      priceLevel: {
        id: null,
        name: null,
        isPercentage: null,
        percent: null,
        withVat: null,
        currency: {
          id: null,
          name: null,
        },
        externalId: null,
      },
    },
    tags: {
      id: null,
      name: null,
      type: null,
      color: null,
      externalId: null,
    },
    quantities: SchemaUtil.quantity,
    sellItems: SchemaUtil.sellItem,
    isDeletable: null,
    dimensionX: null,
    dimensionY: null,
    dimensionZ: null,
    originCountry: null,
    hsCode: null,
  }

  static mainImageSchema = {
    id: null,
    text: null,
    originalFilename: null,
    main: null,
    mimeType: null,
    size: null,
    url: null,
    thumbnails: {
      format: null,
      mimeType: null,
      url: null,
    },
  }

  static inventoryExport = {
    id: null,
    date: null,
    generated: null,
    created: null,
    depots: SchemaUtil.basic,
    suppliers: SchemaUtil.basic,
    producers: SchemaUtil.basic,
    url: null,
    files: SchemaUtil.file,
    approved: null,
    rejected: null,
    finished: null,
    pmpIn: { id: null, url: null },
    pmpOut: { id: null, url: null },
  }
  static producer = {
    id: null,
    name: null,
    externalId: null,
    company: {
      id: null,
      name: null,
    },
  }

  static vat = {
    id: null,
    name: null,
    percent: null,
    default: null,
    coefficient: null,
    externalId: null,
    company: {
      id: null,
      name: null,
    },
    created: null,
    updated: null,
  }

  static tag = {
    id: null,
    name: null,
    type: null,
    color: null,
    externalId: null,
    company: {
      id: null,
      name: null,
    },
    created: null,
    updated: null,
  }

  static supplier = {
    id: null,
    name: null,
    externalId: null,
    deletable: null,
    company: {
      id: null,
      name: null,
    },
  }

  static purchaseOrder = {
    id: null,
    number: null,
    status: {
      id: null,
      name: null,
    },
    createdBy: {
      id: null,
      name: null,
    },
    tags: {
      name: null,
    },
    depot: {
      id: null,
      name: null,
    },
    supplier: {
      id: null,
      name: null,
      externalId: null,
    },
    created: null,
    externalReference: null,
    purchasePriceAll: null,
    purchasePriceAllWithVat: null,
    dateEstimatedArrival: null,
    supplierReference: null,
  }

  static purchaseOrderDetail = {
    id: null,
    status: {
      id: null,
      name: null,
    },
    supplier: { id: null, name: null },
    depot: { id: null, name: null },
    tags: { id: null },
    externalId: null,
    externalReference: null,
    note: null,
    privateNote: null,
    created: null,
    updated: null,
    number: null,
    dateEstimatedArrival: null,
    customData: null,
    createdBy: { name: null, firstName: null, lastName: null },
    items: {
      id: null,
      quantity: null,
      quantityIn: null,
      purchasePrice: null,
      purchasePriceWithVat: null,
      purchasePriceAll: null,
      purchasePriceAllWithVat: null,
      currency: {
        id: null,
      },
      customData: null,
      note: null,
      status: {
        id: null,
        name: null,
      },
      product: {
        id: null,
        name: null,
        fullName: null,
        enabledBatchExpiration: null,
        externalId: null,
        mainImage: {
          url: null,
          thumbnails: {
            format: null,
            url: null,
          },
        },
        code: null,
        ean: null,
        vat: {
          id: null,
          percent: null,
          coefficient: null,
        },
        packs: {
          id: null,
          ean: null,
          code: null,
          quantity: null,
          externalId: null,
          note: null,
        },
        tags: {
          id: null,
          name: null,
          type: null,
          color: null,
          externalId: null,
        },
      },
    },
    excelUrl: null,
    excelWOPricesUrl: null,
    pdfUrl: null,
    pdfWOPricesUrl: null,
  }

  static purchaseOrderWithItemsOnly = {
    items: {
      status: {
        id: null,
        name: null,
      },
      product: {
        id: null,
        name: null,
        fullName: null,
        code: null,
        code2: null,
        code3: null,
        enabledBatchExpiration: null,
        mainImage: {
          id: null,
          text: null,
          originalFilename: null,
          main: null,
          mimeType: null,
          size: null,
          url: null,
          thumbnails: {
            format: null,
            mimeType: null,
            url: null,
          },
        },
        vat: {
          id: null,
          name: null,
          coefficient: null,
        },
        packs: {
          id: null,
          ean: null,
          code: null,
          quantity: null,
          externalId: null,
          note: null,
        },
        tags: {
          id: null,
          name: null,
          type: null,
          color: null,
          externalId: null,
        },
      },
      currency: {
        id: null,
        name: null,
      },
      externalId: null,
      purchasePrice: null,
      purchasePriceWithVat: null,
      purchasePriceAll: null,
      purchasePriceAllWithVat: null,
      quantity: null,
      quantityIn: null,
    },
  }

  static purchaseOrderItems = {
    id: null,
    purchaseOrder: {
      id: null,
      number: null,
      created: null,
      externalReference: null,
      depot: {
        id: null,
        name: null,
      },
      supplier: {
        id: null,
        name: null,
        externalId: null,
      },
    },
    status: {
      id: null,
      name: null,
    },
    product: {
      id: null,
      name: null,
      fullName: null,
      code: null,
      code2: null,
      code3: null,
      enabledBatchExpiration: null,
      mainImage: {
        id: null,
        text: null,
        originalFilename: null,
        main: null,
        mimeType: null,
        size: null,
        url: null,
        thumbnails: {
          format: null,
          mimeType: null,
          url: null,
        },
      },
      vat: {
        id: null,
        name: null,
        coefficient: null,
      },
      packs: {
        id: null,
        ean: null,
        code: null,
        quantity: null,
        externalId: null,
        note: null,
      },
      tags: {
        id: null,
        name: null,
        type: null,
        color: null,
        externalId: null,
      },
    },
    currency: {
      id: null,
      name: null,
    },
    externalId: null,
    purchasePrice: null,
    purchasePriceWithVat: null,
    purchasePriceAll: null,
    purchasePriceAllWithVat: null,
    quantity: null,
    quantityIn: null,
  }

  static productPurchaseOrder = {
    purchaseCurrency: {
      id: null,
      name: null,
    },
    purchasePrice: null,
    id: null,
    name: null,
    fullName: null,
    ean: null,
    code: null,
    code2: null,
    code3: null,
    actualSellPrice: null,
    externalId: null,
    mainImage: SchemaUtil.file,
    packs: {
      id: null,
      ean: null,
      code: null,
      quantity: null,
      externalId: null,
      note: null,
    },
    quantityStock: null,
    quantityReservation: null,
    quantityAvailable: null,
    tags: {
      id: null,
      name: null,
      type: null,
      color: null,
      externalId: null,
    },
    quantities: SchemaUtil.quantity,
    vat: {
      id: null,
      name: null,
      default: null,
      percent: null,
      coefficient: null,
    },
  }

  static productMove = {
    id: null,
    productDepotFrom: {
      id: null,
      depot: { id: null, name: null },
      purchasePrice: null,
      batch: null,
      expirationDate: null,
      position: null,
    },
    productDepotTo: {
      id: null,
      depot: { id: null, name: null },
      purchasePrice: null,
      batch: null,
      expirationDate: null,
      position: null,
    },
    productDepotFromQuantityStock: null,
    productDepotToQuantityStock: null,
    amount: null,
    purchasePrice: null,
    purchasePriceWithVat: null,
    purchasePriceAll: null,
    purchasePriceAllWithVat: null,
    note: null,
    pack: {
      id: null,
      dateCreated: null,
      url: null,
      number: null,
      type: { id: null, name: null },
      checkout: { id: null, name: null },
      purchasePrice: null,
    },
    created: null,
    updated: null,
    deleted: null,
    createdBy: {
      id: null,
      email: null,
      firstName: null,
      lastName: null,
      name: null,
    },
  }

  static productMoveLite = {
    id: null,
    productDepotFromQuantityStock: null,
    productDepotToQuantityStock: null,
    amount: null,
    purchasePrice: null,
    purchasePriceWithVat: null,
    purchasePriceAll: null,
    purchasePriceAllWithVat: null,
    note: null,
    pack: {
      id: null,
      dateCreated: null,
      checkout: { id: null, name: null },
      purchasePrice: null,
    },
    created: null,
    updated: null,
    deleted: null,
  }

  static productMoveForStats = {
    ...SchemaUtil.productMoveLite,
    product: SchemaUtil.productForStats,
  }

  static productMovePackList = {
    id: null,
    dateCreated: null,
    url: null,
    type: {
      id: null,
      name: null,
    },
    note: null,
    number: null,
    checkout: {
      id: null,
      name: null,
    },
    depotFrom: {
      id: null,
      name: null,
    },
    depotTo: {
      id: null,
      name: null,
    },
    moves: {
      id: null,
      amount: null,
    },
    purchasePrice: null,
    createdBy: {
      id: null,
      email: null,
      firstName: null,
      lastName: null,
      name: null,
      enabled: null,
    },
  }

  static productForProductMovePack = {
    id: null,
    name: null,
    fullName: null,
    ean: null,
    code: null,
    purchaseCurrency: {
      id: null,
      name: null,
    },
    purchasePrice: null,
    sellPrice: null,
    sellPriceWithoutVat: null,
    beforeSellPrice: null,
    actualSellPrice: null,
    actualSellPriceWithoutVat: null,
    actualBeforeSellPrice: null,
    weight: null,
    isFragile: null,
    isOversize: null,
    isForSubsequentSettlement: null,
    mainImage: SchemaUtil.mainImageSchema,
    images: {
      id: null,
    },
    files: {
      id: null,
    },
    vat: {
      id: null,
      name: null,
      percent: null,
    },
  }

  static productMovePack = {
    id: null,
    externalId: null,
    dateCreated: null,
    deletable: null,
    purchasePriceWithVat: null,
    url: null,
    incidentalCosts: null,
    purchaseOrder: {
      id: null,
      number: null,
    },
    type: {
      id: null,
      name: null,
    },
    purpose: {
      id: null,
      name: null,
    },
    note: null,
    number: null,
    checkout: {
      id: null,
      name: null,
    },
    depotFrom: {
      id: null,
      name: null,
      unavailablesUrl: null,
    },
    depotTo: {
      id: null,
      name: null,
      unavailablesUrl: null,
    },
    moves: {
      id: null,
      amount: null,
      note: null,
      deletable: null,
      pack: {
        id: null,
      },
      purchasePriceWithVat: null,
      purchasePriceAllWithVat: null,
      product: SchemaUtil.productList,
      created: null,
      updated: null,
      deleted: null,
      createdBy: {
        id: null,
        email: null,
        firstName: null,
        lastName: null,
        name: null,
      },
      productDepotFrom: {
        id: null,
        expirationDate: null,
        batch: null,
        position: null,
        product: SchemaUtil.productList,
        purchasePrice: null,
        supplier: { id: null, name: null },
      },
      productDepotTo: {
        id: null,
        expirationDate: null,
        batch: null,
        position: null,
        product: SchemaUtil.productList,
        purchasePrice: null,
        supplier: { id: null, name: null },
      },
    },
    purchasePrice: null,
    createdBy: {
      id: null,
      email: null,
      firstName: null,
      lastName: null,
      name: null,
    },
    files: {
      id: null,
      text: null,
      originalFilename: null,
      main: null,
      mimeType: null,
      size: null,
      url: null,
      thumbnails: {
        format: null,
        mimeType: null,
        url: null,
      },
    },
  }

  static productFilesAndImages = {
    id: null,
    code: null,
    ean: null,
    name: null,
    fullName: null,
    mainImage: SchemaUtil.file,
    images: SchemaUtil.file,
    files: SchemaUtil.file,
    quantityAvailable: null,
    quantityReservation: null,
    quantityStock: null,
  }

  static voucher = {
    id: null,
    name: null,
    code: null,
    externalId: null,
    discountType: null,
    discountPercent: null,
    discountValue: null,
    maxUse: null,
    validFrom: null,
    validTo: null,
    isValid: null,
    isPayment: null,
    enabled: null,
    used: null,
  }

  static productPack = {
    id: null,
    product: {
      id: null,
      tags: {
        id: null,
        name: null,
        type: null,
      },
      packs: {
        quantity: null,
      },
    },
    ean: null,
    code: null,
    quantity: null,
    externalId: null,
  }
}
